import { getEmbedConfig } from '../lib/data';
import { encodeGcpLogsExplorerQuery } from '../lib/util/google_console';

const LOGS_EXPLORER_URL = 'https://console.cloud.google.com/logs/query';

export const getCloudLoggingUrl = (searchTerms: (string | null)[]): string => {
  const query = searchTerms
    .filter((term): term is string => term !== null && term !== '')
    .map((term) => `"${term.replace(/["\\]/g, '')}"`)
    .join(' OR ');
  const project = getEmbedConfig()?.gcp_logs_explorer_project;
  return `${LOGS_EXPLORER_URL};query=${encodeGcpLogsExplorerQuery(query)}?project=${project}`;
};
